export const HANDLE_USER_DATA = 'handleUserData';
